import { AppMode } from './AppMode';

export interface GeneralAppState {
    appMode: AppMode;
    machineId: string;
    appTimestamp: Date;
    /*
     * Build version retrieved from the server following the latest "READY" availability message
     * We can compare this with the version in globals, which is the current version running in the browser
     * */
    buildVersion?: string;
}

export const initialGeneralAppState: GeneralAppState = {
    appMode: AppMode.STANDALONE,
    appTimestamp: new Date(),
    machineId: '',
};
